import React from 'react';
import classnames from 'classnames';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import CloseSmall from '@wix/da-ds/pkg/Icons/CloseSmall';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './CloseButton.scss';
export var CloseButton = function (_a) {
    var _b = _a.view, view = _b === void 0 ? 'b5-1' : _b, href = _a.href, onClick = _a.onClick, iconSize = _a.iconSize, className = _a.className, type = _a.type, biData = _a.biData, ariaLabel = _a["aria-label"];
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['root'], s[view], className), onClick: onClick, type: type, biData: biData, "aria-label": ariaLabel, href: href }, view === 'b5-2' ? (React.createElement(CloseSmall, { className: s['icon'], size: iconSize }) // I32A
    ) : (React.createElement(CloseBold, { className: s['icon'], size: iconSize }) // I32
    )));
};
CloseButton.displayName = 'CloseButton';
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map